import { Groups } from "@mui/icons-material";
import { Link, Typography } from "@mui/material";
import { useState } from "react";
import { EditTaskItemTeamModal, ItemProperty } from "src/components";
import { Links } from "src/constants";
import { TaskItemDetailDto } from "src/http";
import { ITeamSummary } from "src/models";

interface Props {
  taskItem: TaskItemDetailDto;
  onTeamChanged?: (selectedTeam: ITeamSummary | null) => void;
}

const TaskItemTeamProperty = (props: Props) => {
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);

  function handleTeamChanged(selectedTeam: ITeamSummary | null) {
    setIsEditModalVisible(false);
    props.onTeamChanged?.(selectedTeam);
  }

  return (
    <>
      <ItemProperty
        labelIcon={<Groups />}
        label="Team"
        canEdit={props.taskItem.userCanEdit}
        onEditClicked={() => setIsEditModalVisible(true)}
      >
        {props.taskItem.team ? (
          <Typography noWrap>
            <Link href={Links.TeamImplementation(props.taskItem.team.slug)}>{props.taskItem.team.name}</Link>
          </Typography>
        ) : (
          <Typography variant="placeholder">Add task to a team</Typography>
        )}
      </ItemProperty>

      {props.taskItem.userCanEdit && (
        <EditTaskItemTeamModal
          open={isEditModalVisible}
          taskItem={props.taskItem}
          onUpdated={handleTeamChanged}
          onCancelled={() => setIsEditModalVisible(false)}
        />
      )}
    </>
  );
};

export { TaskItemTeamProperty };
